(function () {
  const root = (window.Douxcou = window.Douxcou || {});
  const routes = window.routes || { cart_add_url: "/cart/add", cart_change_url: "/cart/change", cart_url: "/cart", root_url: "/" };

  function cartSectionIds() {
    const ids = new Set(["cart-icon-bubble"]);
    document.querySelectorAll("[data-cart-section]").forEach((el) => ids.add(el.dataset.cartSection));
    return [...ids].slice(0, 5);
  }

  function renderSections(sections) {
    if (!sections) return;
    const parser = new DOMParser();
    Object.entries(sections).forEach(([id, html]) => {
      if (!html) return;
      const doc = parser.parseFromString(html, "text/html");
      document.querySelectorAll(`[data-cart-section="${id}"]`).forEach((target) => {
        const source = doc.querySelector(`[data-cart-section="${id}"]`);
        if (source) target.innerHTML = source.innerHTML;
      });
      if (id === "cart-icon-bubble") {
        const source = doc.querySelector("#cart-icon-bubble");
        document.querySelectorAll("#cart-icon-bubble").forEach((t) => source && (t.innerHTML = source.innerHTML));
      }
    });
  }

  async function post(url, body, withSections = true) {
    const payload = withSections ? { ...body, sections: cartSectionIds(), sections_url: window.location.pathname } : body;
    const res = await fetch(`${url}.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || "Erreur panier");
    return data;
  }

  // `cart` = réponse de /cart/update ou /cart/change (déjà le panier complet), sinon on le recharge
  async function refreshCart(sections, cart) {
    renderSections(sections);
    if (!cart || !cart.items) {
      cart = await fetch(`${routes.cart_url}.js`, { headers: { Accept: "application/json" } }).then((r) => r.json());
    }
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
    return cart;
  }

  root.cart = {
    async add(items, { openDrawer = true } = {}) {
      const code = window.autoDiscountCode;
      let data;
      if (code) {
        // Ajout, puis (ré)application du code promo automatique dans la même requête que le rendu du tiroir
        // (Shopify vérifie lui-même les conditions) : 2 requêtes au lieu de 4
        await post(routes.cart_add_url, { items }, false);
        data = await post(`${routes.cart_url}/update`, { discount: code }).catch(() => post(`${routes.cart_url}/update`, {}));
      } else {
        data = await post(routes.cart_add_url, { items });
      }
      const cart = await refreshCart(data.sections, data);
      if (openDrawer) root.drawer.open();
      return cart;
    },
    async change(line, quantity) {
      const data = await post(routes.cart_change_url, { id: line, quantity });
      return refreshCart(data.sections, data);
    },
    // updates = { clé de ligne ou id de variante : quantité } en une seule requête
    async update(updates) {
      const data = await post(`${routes.cart_url}/update`, { updates });
      return refreshCart(data.sections, data);
    },
    get: () => fetch(`${routes.cart_url}.js`).then((r) => r.json()),
  };

  root.drawer = {
    open() {
      document.dispatchEvent(new CustomEvent("cart-drawer:open"));
    },
    close() {
      document.dispatchEvent(new CustomEvent("cart-drawer:close"));
    },
  };

  root.search = {
    open() {
      document.dispatchEvent(new CustomEvent("search:open"));
    },
    close() {
      document.dispatchEvent(new CustomEvent("search:close"));
    },
  };

  root.formatMoney = function (cents) {
    const format = window.moneyFormat || "{{amount_with_comma_separator}} €";
    const value = (Number(cents) / 100).toFixed(2);
    const [int, dec] = value.split(".");
    const withSep = (sep, decSep) => int.replace(/\B(?=(\d{3})+(?!\d))/g, sep) + decSep + dec;
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, kind) => {
      switch (kind) {
        case "amount_with_comma_separator":
          return withSep(".", ",");
        case "amount_no_decimals_with_comma_separator":
          return int.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        case "amount_no_decimals":
          return int.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        case "amount_with_space_separator":
          return withSep(" ", ",");
        default:
          return withSep(",", ".");
      }
    });
  };

  root.lockScroll = (locked) => document.body.classList.toggle("overflow-hidden", locked);

  // Bouton « Paiement sécurisé » : la caisse met 1 à 3 s à s'ouvrir sur mobile, on montre que ça charge
  // et on évite le double envoi (clics répétés vus dans les stats)
  document.addEventListener("submit", (e) => {
    const btn = e.submitter && e.submitter.name === "checkout" ? e.submitter : e.target.querySelector('button[name="checkout"]');
    if (!btn) return;
    if (btn.getAttribute("aria-busy") === "true") return e.preventDefault();
    btn.dataset.label = btn.innerHTML;
    btn.setAttribute("aria-busy", "true");
    btn.style.opacity = "0.75";
    btn.textContent = "Ouverture du paiement…";
  });
  window.addEventListener("pageshow", () => {
    document.querySelectorAll('button[name="checkout"][aria-busy="true"]').forEach((b) => {
      b.removeAttribute("aria-busy");
      b.style.opacity = "";
      if (b.dataset.label) b.innerHTML = b.dataset.label;
    });
  });

  document.documentElement.classList.replace("no-js", "js");
})();
